
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/our-story",
      function () {
        return require("private-next-pages/severalbrands/our-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/our-story"])
      });
    }
  